import { BarLoader, CircleLoader, GridLoader } from 'react-spinners';
import theme from '@/shared/theme/index.module.scss';
import React from 'react';

export default function Loading({ type = 'grid' }: { type?: 'grid' | 'bar' | 'spin' }) {
  switch (type) {
    case 'bar':
      return (
        <div style={{ textAlign: 'center' }} className={'mt-5'}>
          <BarLoader color={theme.info} />
        </div>
      );
    default:
    case 'grid':
      return (
        <div style={{ textAlign: 'center' }} className={'mt-5'}>
          <GridLoader color={theme.info} />
        </div>
      );
    case 'spin':
      return (
        <div style={{ textAlign: 'center' }} className={'mt-5'}>
          <CircleLoader color={theme.info} />
        </div>
      );
  }
}
